<script setup lang="ts">
import { defineAsyncComponent, ref, watch } from 'vue';
import { useLectureStore, useUserStore } from '../../../../stores';
import { UserRole } from '../../../../types/user';
import { LectureTheme, LectureView } from '../../../../types/lecture';

const { theme = LectureTheme.default } = defineProps<{
    theme?: LectureTheme
}>()

// TODO: update other component code splitting with async component
const themeComponentMap = {
    [LectureTheme.default]: defineAsyncComponent(() => import(`./themes/default/Default.vue`)),
}

const user = useUserStore()
const lecture = useLectureStore()
const view = ref<LectureView>(user.userRole === UserRole.student && lecture.isSubmitted ? LectureView.submmited : LectureView.question)

// show student submitted screen when teacher turn off view answer option and student is reviewing question
watch(() => lecture.studentViewAnswer, () => {
    if (user.userRole !== UserRole.student) return;
    if (!lecture.isSubmitted) return;
    if (view.value !== LectureView.question) return;

    view.value = LectureView.submmited
})

// show submitted screen when student submit lecture
watch(() => lecture.isSubmitted, () => {
    if (user.userRole !== UserRole.student) return;
    if (!lecture.isSubmitted) return;

    view.value = LectureView.submmited
})
</script>

<template>
    <div class="h-full w-full flex flex-col justify-between overflow-y-auto overflow-x-hidden">
        <component :is="themeComponentMap[theme]" v-model="view"></component>
    </div>
</template>